import {
  FOREST_PATH,
  LEAGUE_PATH,
  ROOT_PATH,
  MY_READINGS_MODULAR_PATH,
  ACTIVITIES_PATH,
  COMUNICAR_STORY_TREE_HOME_ROOT_PATH
} from 'routes/paths'
import { getImageUrl } from 'utils/assets/Cdn'
import type { HotspotConfig } from './HomeStoryTree.types'
import { criarUrl } from 'components/modular/tabs-home/constants'

export const JOURNEYS_PATH = `${ROOT_PATH}/journey`

export const SVG_DIMENSIONS = {
  LARGE: { width: 1996, height: 933 },
  SMALL: { width: 1440, height: 1000 }
} as const

export const SCREEN_BREAKPOINT = 930

export const HOTSPOT_CONFIGS: HotspotConfig[] = [
  {
    id: 'storyMaker',
    path: criarUrl,
    label: 'Story Maker',
    zIndex: 3
  },
  {
    id: 'library',
    path: COMUNICAR_STORY_TREE_HOME_ROOT_PATH,
    label: 'Library',
    zIndex: 3
  },
  {
    id: 'forest',
    path: FOREST_PATH,
    label: 'Forest',
    zIndex: 1
  },
  {
    id: 'journeys',
    path: JOURNEYS_PATH,
    label: 'Journeys',
    zIndex: 3
  },
  {
    id: 'leaderboard',
    path: LEAGUE_PATH,
    label: 'Leaderboard',
    zIndex: 1
  },
  {
    id: 'myReadings',
    path: MY_READINGS_MODULAR_PATH,
    label: 'My Readings',
    zIndex: 3
  },
  {
    id: 'assignments',
    path: ACTIVITIES_PATH,
    label: 'Assignments',
    zIndex: 3
  }
]

export const HOTSPOT_POSITIONS = {
  LARGE: {
    leaderboard: {
      leftPercent: 24,
      topPercent: 53,
      widthPercent: 17,
      heightPercent: 25
    },
    journeys: {
      leftPercent: 22,
      topPercent: 6.2,
      widthPercent: 17,
      heightPercent: 25
    },
    forest: {
      leftPercent: 62.5,
      topPercent: 28.5,
      widthPercent: 17,
      heightPercent: 25
    },
    storyMaker: {
      leftPercent: 62.5,
      topPercent: 2,
      widthPercent: 17,
      heightPercent: 25
    },
    library: {
      leftPercent: 42.5,
      topPercent: 28,
      widthPercent: 17,
      heightPercent: 25
    },
    hillBackground: {
      leftPercent: 45,
      topPercent: 60,
      widthPercent: 40,
      heightPercent: 60
    }
  },
  SMALL: {
    leaderboard: {
      leftPercent: 12,
      topPercent: 48,
      widthPercent: 25,
      heightPercent: 30
    },
    journeys: {
      leftPercent: 5.8,
      topPercent: 8,
      widthPercent: 25,
      heightPercent: 30
    },
    forest: {
      leftPercent: 70.5,
      topPercent: 32,
      widthPercent: 25,
      heightPercent: 30
    },
    storyMaker: {
      leftPercent: 67.7,
      topPercent: 4,
      widthPercent: 25,
      heightPercent: 30
    },
    library: {
      leftPercent: 38.6,
      topPercent: 27,
      widthPercent: 25,
      heightPercent: 30
    },
    hillBackground: {
      leftPercent: 40,
      topPercent: 58.7,
      widthPercent: 60,
      heightPercent: 60
    },
    myReadings: {
      leftPercent: 65,
      topPercent: 77,
      widthPercent: 18,
      heightPercent: 18
    },
    assignments: {
      leftPercent: 77,
      topPercent: 77,
      widthPercent: 18,
      heightPercent: 18
    }
  }
} as const

export const BACKGROUND_IMAGES = [
  getImageUrl('story-tree/background-story-tree.svg'),
  getImageUrl('story-tree/background-story-tree-v1.svg'),
  getImageUrl('story-tree/leaderboard.svg'),
  getImageUrl('story-tree/leaderboard-hover.svg'),
  getImageUrl('story-tree/journeys.svg'),
  getImageUrl('story-tree/journeys-hover.svg'),
  getImageUrl('story-tree/story-maker.svg'),
  getImageUrl('story-tree/story-maker-hover.svg'),
  getImageUrl('story-tree/library.svg'),
  getImageUrl('story-tree/library-hover.svg'),
  getImageUrl('story-tree/forest.svg'),
  getImageUrl('story-tree/forest-hover.svg'),
  getImageUrl('story-tree/my-readings.svg'),
  getImageUrl('story-tree/assignments.svg'),
  getImageUrl('story-tree/assignments-alert.svg'),
  getImageUrl('story-tree/hill-background.svg')
]
